<template>
    <div
        :class="{
            'nav-container': true,
            'is-clearfix': true,
            'nav-container__no-tabs': !showTabs
        }"
    >
        <div v-if="responsiveDesignNav" class="nav-live">
            <navigation-top-bar />
            <navigation-tabs v-if="showTabs" />
        </div>
        <div v-else class="container nav-container old-nav-container is-clearfix">
            <div class="live-nav">
                <div v-for="link in links" :key="link.routeName">
                    <a v-if="link.show" :class="{ active: $route.name === link.routeName }" @click="handleClick(link)">
                        {{ link.text }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { computed } from 'vue-demi';
    import { useContactStore, useAuthStore } from '../../../stores';
    import useRouter from '../../composables/use-router';
    import NavigationTopBar from './navigation/NavigationTopBar.vue';
    import NavigationTabs from './navigation/NavigationTabs.vue';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'NavigationMenu',
        components: {
            NavigationTopBar,
            NavigationTabs
        },

        props: {
            responsiveDesignNav: {
                type: Boolean,
                default: false
            }
        },
        setup(props, context) {
            const contact = useContactStore().data;
            const router = useRouter().get();

            const showPayouts = computed(() => {
                return (
                    (context.root.account_makes_payments || context.root.account_show_payouts_on_live_url) &&
                    useAuthStore().isLoggedIn &&
                    contact.last_verified_email
                );
            });

            const showTabs = computed(() => context.root.$route.name !== 'edit.profile');

            const links = [
                {
                    text: 'Dashboard',
                    routeName: 'sponsorships',
                    show: true
                },
                {
                    text: 'Insights',
                    routeName: 'insights',
                    show: true
                },
                {
                    text: 'Network Connections',
                    routeName: 'manage.networks',
                    show: true
                },
                {
                    text: 'Settings',
                    routeName: 'edit.profile',
                    show: true
                },
                {
                    text: 'Payouts',
                    routeName: 'payments.dashboard',
                    show: showPayouts.value
                }
            ];

            const handleClick = (link) => {
                const to = router.resolve({ name: link.routeName });

                context.root.go(link.routeName);
            };

            return {
                links,
                handleClick,
                showTabs
            };
        }
    };
</script>

<style lang="scss" scoped>
    .live-nav {
        background-color: darken(#303c4a, 5%);
        padding: 8px 16px;
        float: left;
        width: 100%;
        a {
            color: #fff;
            float: left;
            display: block;
            padding: 5px;
            margin-right: 10px;
            opacity: 0.6;

            &.active {
                opacity: 1;
            }
        }
    }

    .nav-container {
        z-index: 999;
    }

    .old-nav-container {
        height: 79px;
    }
</style>
